import Room from 'ipfs-pubsub-room'
import * as IPFS from 'ipfs'
import { ReplaySubject, from } from 'rxjs';
import { map } from 'rxjs/operators'
import { PEER_JOINED, PEER_LEFT, SUBCRIBED, MESSAGE } from '../constants/ipfsP2PRoomEvents.constants.';

export default class RoomService {

    constructor(hash, roomName){
        this.ipfsNode = IPFS.create({});
        this.ipfsNodeObservable = from(this.ipfsNode);
        const unqiueRoomName = hash + '_' + roomName;
        () => {
            this.GetIPFSNodeObservable().pipe(
                map((node) => {
                    this.Room = new Room(node, unqiueRoomName);
                    this.InitializeReplaySubject(this.PeerJoin);
                    this.InitializeReplaySubject(this.PeerLeft);
                    this.InitializeReplaySubject(this.Connection);
                    this.InitializeReplaySubject(this.Events);
                })
            )
        };
    }

    GetIPFSNodeObservable(){
        return this.ipfsNodeObservable;
    }

    // Wish this could be private...maybe too verbose and inorder to statisfy DRY and maybe contradicts KISS
    InitializeReplaySubject(subject){
       subject = new ReplaySubject();
       return subject;
    }

    ValidateReplaySubject(subject){
        return subject && subject.isStopped;
    }

    GetRoomP2PEventSubject(p2pEventName, subject){
        if(this.ValidateReplaySubject(subject)){
            this.InitializeReplaySubject(subject)
        }

        this.Room.on(p2pEventName, (eventPayload) => {
            subject.next(eventPayload);
        });

        return subject;
    }

    SendEvent(stateEvent) {
        return this.Room.broadcast(stateEvent);
    }

    ObservePeerJoinRequest(){
        return this.GetRoomP2PEventSubject(PEER_JOINED, this.PeerJoin);
    }

    ObservePeerLeftEvent(){
        return this.GetRoomP2PEventSubject(PEER_LEFT, this.PeerLeft);
    }

    ObserveRoomConnection(){
        return this.GetRoomP2PEventSubject(SUBCRIBED, this.Connection);
    }

    ObserveRoomEvents(){
        return this.GetRoomP2PEventSubject(MESSAGE, this.Events);
    }  
  }